import { Box, Typography } from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import { AppState } from "../../core/app/AppReducer";
import CheckMark from "../../core/assets/common/check-mark.png";
import { BaseAutocompleteProps } from "../../core/components/autocomplete/UseAutocomplete";
import MixPoolPlaceAutocomplete from "./MixPoolPlaceAutocomplete";
import { BombBag, Bow, DinsFire, HookShot, IronBoots, MegatonHammer, OotItemDto, Sos, Strength1, Strength2, Strength3, ZL, ZoraScale } from "../hints/OotItemAutocomplete";

const MixPoolNotes = () => {
    let isMixedPoolGrotto = useSelector((state: AppState) => state.ui.ootr.main.isMixedPoolGrotto)
    let isMixedPoolInterior = useSelector((state: AppState) => state.ui.ootr.main.isMixedPoolInterior)
    let isMixedPoolDungeon = useSelector((state: AppState) => state.ui.ootr.main.isMixedPoolDungeon)

    if (!isMixedPoolDungeon && !isMixedPoolGrotto && !isMixedPoolInterior)
        return null;

    return <Box maxHeight="700px" maxWidth="90vw" display={"flex"} flexDirection={"column"} flexWrap={"wrap"}>
        <table width={350}>
            <tr ><td colSpan={4} style={{ border: "1px solid green" }}><Typography textAlign={"center"} color={"green"} fontWeight={"bold"}>Forest</Typography></td></tr>
            <Zone name="KF" zone="KF" />
            <Zone name="LW" zone="LW" />
            <Zone name="SFM" zone="SFM" />
            {isMixedPoolDungeon && <Zone name="Dungeons" zone="Forest" />}
        </table>
        <table width={350}>
            <tr><td colSpan={4} style={{ border: "1px solid lightblue" }}><Typography textAlign={"center"} color={"lightblue"} fontWeight={"bold"}>River</Typography></td></tr>
            <Zone name="River" zone="ZR" />
            <Zone name="Domain" zone="ZD" />
            <Zone name="Fountain" zone="ZF" />
            <Zone name="Lake" zone="LH" />
            {isMixedPoolDungeon && <Zone name="Dungeons" zone="River" />}
        </table>
        <table width={350}>
            <tr><td colSpan={4} style={{ border: "1px solid lightblue" }}><Typography textAlign={"center"} color={"lightblue"} fontWeight={"bold"}>Lon Lon ranch</Typography></td></tr>
            <Zone name="Ranch" zone="LLR" />
        </table>
        <table width={350}>
            <tr><td colSpan={4} style={{ border: "1px solid #D0BDF0" }}><Typography textAlign={"center"} color={"#D0BDF0"} fontWeight={"bold"}>Kakarico</Typography></td></tr>
            <Zone name="KAK" zone="KAK" />
            <Zone name="GY" zone="GY" />
            {isMixedPoolDungeon && <Zone name="Dungeons" zone="Kakarico" />}
        </table>
        <table width={350}>
            <tr><td colSpan={4} style={{ border: "1px solid red" }}><Typography textAlign={"center"} color={"red"} fontWeight={"bold"}>Mountain</Typography></td></tr>
            <Zone name="DMT" zone="DMT" />
            <Zone name="DMC" zone="DMC" />
            <Zone name="GC" zone="GC" />
            {isMixedPoolDungeon && <Zone name="Dungeons" zone="Mountain" />}
        </table>
        <table width={350}>
            <tr><td colSpan={4} style={{ border: "1px solid orange" }}><Typography textAlign={"center"} color={"orange"} fontWeight={"bold"}>Desert</Typography></td></tr>
            <Zone name="GV" zone="GV" />
            <Zone name="GF" zone="GF" />
            <Zone name="Colossus" zone="Coloss" />
            {isMixedPoolDungeon && <Zone name="Dungeons" zone="Desert" />}
        </table>
        <table width={350}>
            <tr><td colSpan={4} style={{ border: "1px solid lightgrey" }}><Typography textAlign={"center"} color={"lightgrey"} fontWeight={"bold"}>Hyrule</Typography></td></tr>
            <Zone name="HC" zone="HC" />
            <Zone name="OGC" zone="OGC" />
            <Zone name="Market" zone="MKT" />
            <Zone name="HF" zone="HF" />
        </table>
    </Box>

}

export default MixPoolNotes;

interface ZoneProps {
    name: string
    zone: string
}

const Zone = (props: ZoneProps) => {
    let isMixedPoolGrotto = useSelector((state: AppState) => state.ui.ootr.main.isMixedPoolGrotto)
    let isMixedPoolInterior = useSelector((state: AppState) => state.ui.ootr.main.isMixedPoolInterior)
    let isMixedPoolDungeon = useSelector((state: AppState) => state.ui.ootr.main.isMixedPoolDungeon)
    let isMixedPoolOverworld = useSelector((state: AppState) => state.ui.ootr.main.isMixedPoolOverworld)

    let checks: Array<MixPoolPlace> = [];
    if (isMixedPoolInterior)
        checks = [...Interiors.filter(x => x.zone === props.zone)]
    if (isMixedPoolGrotto)
        checks = [...checks, ...Grottos.filter(x => x.zone === props.zone)]
    if (isMixedPoolDungeon)
        checks = [...checks, ...Dungeons.filter(x => x.zone === props.zone)]
    if (isMixedPoolOverworld)
        checks = [...checks, ...OverworldEntrances.filter(x => x.zone === props.zone)]
    return <>
        <tr><td rowSpan={checks.length + 1}>{props.name}</td></tr>
        {checks.map(check => <EntranceCheck name={check.name} />)}
    </>
}


interface EntranceCheckProps {
    name: string,
}
const EntranceCheck = (props: EntranceCheckProps) => {


    let [isCheck, setIsCheck] = useState(false);
    return <tr>
        <td width={150}>{props.name}</td>
        <td>
            <MixPoolPlaceAutocomplete />
        </td>
        <td onClick={() => setIsCheck(!isCheck)} style={{ border: "1px solid white" }} height={"18px"} width="50px">
            {isCheck && <img src={CheckMark} alt="check" width="18px" height="18px" />}
        </td>
    </tr>


}


export const Interiors: Array<MixPoolPlace> = [
    //KF
    { name: "KF Mido", type: "interior", autocompleteName: "Mido", isImportant: false, zone: "KF", globalArea: "Foret"  },
    { name: "KF Bro", type: "interior", autocompleteName: "X", isImportant: false, zone: "KF", globalArea: "Foret"  },
    { name: "KF Link", type: "interior", autocompleteName: "Link", isImportant: false, zone: "KF", globalArea: "Foret"  },
    { name: "KF Saria", type: "interior", autocompleteName: "X", isImportant: false, zone: "KF", globalArea: "Foret"  },
    { name: "KF Twin", type: "interior", autocompleteName: "X", isImportant: false, zone: "KF", globalArea: "Foret"  },
    { name: "KF Kokiri_Shop", type: "interior", autocompleteName: "KF Shop", isImportant: true, zone: "KF", globalArea: "Foret"  },



    //ZD
    { name: "ZD Zora_Shop", type: "interior", autocompleteName: "Zora Shop", isImportant: true, zone: "ZD", globalArea: "Zora"  },
    //ZF
    { name: "ZF Fairy", type: "interior", autocompleteName: "Great Fairy", isImportant: false, zone: "ZF", globalArea: "Zora", itemRestricted: [BombBag]  },
    //LH
    { name: "LH Lab", type: "interior", autocompleteName: "Lab", isImportant: true, zone: "LH", globalArea: "Zora"  },
    { name: "LH Fishing", type: "interior", autocompleteName: "Fishing", isImportant: true, zone: "LH", globalArea: "Zora"  },

    //KAK
    { name: "KAK party", type: "interior", autocompleteName: "X", isImportant: false, zone: "KAK", globalArea: "Kak" },
    { name: "KAK Bazar", type: "interior", autocompleteName: "Bazar", isImportant: true, zone: "KAK", globalArea: "Kak", eraRestricted: "adult" },
    { name: "KAK Potion_Front", type: "interior", autocompleteName: "Potion Front", isImportant: true, zone: "KAK", globalArea: "Kak" },
    { name: "KAK Potion_Back", type: "interior", autocompleteName: "Potion Back", isImportant: true, zone: "KAK", globalArea: "Kak", eraRestricted: "adult" },
    { name: "KAK Apo", type: "interior", autocompleteName: "X", isImportant: false, zone: "KAK", globalArea: "Kak" , eraRestricted: "adult"},
    { name: "KAK Windmill", type: "interior", autocompleteName: "Windmill", isImportant: true, zone: "KAK", globalArea: "Kak" },
    { name: "KAK Impa_Back", type: "interior", autocompleteName: "Impa Back (Cow)", isImportant: true, zone: "KAK", globalArea: "Kak" },
    { name: "KAK Impa_Front", type: "interior", autocompleteName: "Impa Front (Cow)", isImportant: true, zone: "KAK", globalArea: "Kak" },
    { name: "KAK Archery", type: "interior", autocompleteName: "Adult Archery", isImportant: true, zone: "KAK", globalArea: "Kak", eraRestricted: "adult" },
    { name: "KAK Skull", type: "interior", autocompleteName: "Skull House", isImportant: true, zone: "KAK", globalArea: "Kak" },

    //GY
    { name: "GY Dampe_Hut", type: "interior", autocompleteName: "Dampe Hut", isImportant: true, zone: "GY", globalArea: "Kak" },

    //GV
    { name: "GV Tent", type: "interior", autocompleteName: "Tent", isImportant: true, zone: "GV", globalArea: "Desert" },

     //GF

    //Coloss
    { name: "Coloss Fairy", type: "interior", autocompleteName: "Great Fairy", isImportant: true, zone: "Coloss", globalArea: "Desert", itemRestricted: [BombBag]  },

    //HC
    { name: "HC Fairy", type: "interior", autocompleteName: "Great Fairy", isImportant: true, zone: "HC", globalArea: "Castle", eraRestricted: "child", itemRestricted: [BombBag] },
    //OGC
    { name: "OGC Fairy", type: "interior", autocompleteName: "Great Fairy", isImportant: true, zone: "HC", globalArea: "Castle", eraRestricted: "adult", itemRestricted: [Strength3]  },
    { name: "OGC => Ganon_Castle", type: "interior", autocompleteName: "Ganon's Tower", isImportant: true, zone: "HC", globalArea: "Castle", eraRestricted: "adult" },

    //MKT
    { name: "MKT_Bridge Pot_Poe", type: "interior", autocompleteName: "Pot/Poe", isImportant: true, zone: "MKT_Bridge", globalArea: "Castle" },
    { name: "MKT Bazar", type: "interior", autocompleteName: "Bazar", isImportant: true, zone: "MKT", globalArea: "Castle", eraRestricted: "child"  },
    { name: "MKT Potion", type: "interior", autocompleteName: "Potion", isImportant: true, zone: "MKT", globalArea: "Castle", eraRestricted: "child"  },
    { name: "Out_ToT ToT", type: "interior", autocompleteName: "ToT", isImportant: true, zone: "Out_ToT", globalArea: "Castle" },
    { name: "MKT Mask", type: "interior", autocompleteName: "Mask", isImportant: true, zone: "MKT", globalArea: "Castle", eraRestricted: "child"  },
    { name: "MKT Sling", type: "interior", autocompleteName: "Sling", isImportant: true, zone: "MKT", globalArea: "Castle", eraRestricted: "child"  },
    { name: "MKT Bowling", type: "interior", autocompleteName: "Bowling", isImportant: true, zone: "MKT", globalArea: "Castle", eraRestricted: "child"  },
    { name: "MKT CMG", type: "interior", autocompleteName: "CMG", isImportant: true, zone: "MKT", globalArea: "Castle", eraRestricted: "child"  },
    { name: "MKT Chus_Shop", type: "interior", autocompleteName: "Chus Shop", isImportant: true, zone: "MKT", globalArea: "Castle", eraRestricted: "child" },
    { name: "MKT Back_Alley", type: "interior", autocompleteName: "X", isImportant: false, zone: "MKT", globalArea: "Castle" },

    //LLR
    { name: "LLR Talon", type: "interior", autocompleteName: "Talon", isImportant: true, zone: "LLR", globalArea: "Castle" },
    { name: "LLR Stables", type: "interior", autocompleteName: "Stables (Cow)", isImportant: true, zone: "LLR", globalArea: "Castle" },
    { name: "LLR Silo", type: "interior", autocompleteName: "Silo (Cow)", isImportant: true, zone: "LLR", globalArea: "Castle"  },

    //DMT
    { name: "DMT Fairy", type: "interior", autocompleteName: "Great Fairy", isImportant: true, zone: "DMT", globalArea: "Mountain" },

    //DMC
    { name: "DMC Fairy", type: "interior", autocompleteName: "Great Fairy", isImportant: true, zone: "DMC", globalArea: "Mountain" },

    //GC
    { name: "GC Goron_Shop", type: "interior", autocompleteName: "Goron Shop", isImportant: true, zone: "GC", globalArea: "Mountain"  },



]

export const Grottos: Array<MixPoolPlace> = [
    //KF
    { name: "KF Sos", type: "grotto", autocompleteName: "generic grotto", isImportant: true, zone: "KF", globalArea: "Foret", itemRestricted: [Sos]  },
    //LW
    { name: "LW GC_Boulder", type: "grotto", autocompleteName: "generic grotto", isImportant: true, zone: "LW", globalArea: "Foret", itemRestricted: [BombBag, MegatonHammer]  },
    { name: "LW Scrub_Boulder", type: "grotto", autocompleteName: "2 Scrub grotto", isImportant: true, zone: "LW", globalArea: "Foret", itemRestricted: [BombBag, MegatonHammer]  },
    { name: "LW Theater", type: "grotto", autocompleteName: "Theater", isImportant: true, zone: "LW", globalArea: "Foret"  },
    //SFM
    { name: "SFM Wolfos", type: "grotto", autocompleteName: "Wolf grotto", isImportant: true, zone: "SFM", globalArea: "Foret", itemRestricted: [BombBag, MegatonHammer]  },
    { name: "SFM Free", type: "grotto", autocompleteName: "X", isImportant: false, zone: "SFM", globalArea: "Foret"  },
    { name: "SFM Sos", type: "grotto", autocompleteName: "2 Scrub grotto", isImportant: true, zone: "SFM", globalArea: "Foret", itemRestricted: [Sos]   },
    //ZR
    { name: "ZR Sos", type: "grotto", autocompleteName: "2 Scrub grotto", isImportant: true, zone: "ZR", globalArea: "Zora", itemRestricted: [Sos]  },
    { name: "ZR Free", type: "grotto", autocompleteName: "generic grotto", isImportant: true, zone: "ZR", globalArea: "Zora" },
    { name: "ZR Boulder", type: "grotto", autocompleteName: "X", isImportant: true, zone: "ZR", globalArea: "Zora", itemRestricted: [BombBag, MegatonHammer] },
    //ZD
    { name: "ZD Sos", type: "grotto", autocompleteName: "X", isImportant: true, zone: "ZD", globalArea: "Zora", itemRestricted: [Sos]  },
    //LH
    { name: "LH Scrub", type: "grotto", autocompleteName: "3 Scrub grotto", isImportant: true, zone: "LH", globalArea: "Zora" },

    //KAK
    { name: "KAK Free", type: "grotto", autocompleteName: "generic grotto", isImportant: true, zone: "KAK", globalArea: "Kak" },
    { name: "KAK ReDead", type: "grotto", autocompleteName: "ReDead", isImportant: true, zone: "KAK", globalArea: "Kak", itemRestricted: [BombBag, MegatonHammer] },
    //GY
    { name: "GY Shield_Grave", type: "grotto", autocompleteName: "Shield Grave", isImportant: true, zone: "GY", globalArea: "Kak" },
    { name: "GY Dampe_Race", type: "grotto", autocompleteName: "Dampe Race", isImportant: true, zone: "GY", globalArea: "Kak", eraRestricted: "adult" },
    { name: "GY Sun_Song_Grave", type: "grotto", autocompleteName: "Sun Song Grave", isImportant: true, zone: "GY", globalArea: "Kak" },
    { name: "GY Royal_Tomb", type: "grotto", autocompleteName: "Royal Tomb", isImportant: true, zone: "GY", globalArea: "Kak", itemRestricted: [ZL]   },

    //GV
    { name: "GV Sos", type: "grotto", autocompleteName: "2 Scrub grotto", isImportant: true, zone: "GV", globalArea: "Desert", itemRestricted: [Sos], eraRestricted: "adult"    },
    { name: "GV Boulder", type: "grotto", autocompleteName: "X", isImportant: false, zone: "GV", globalArea: "Desert", itemRestricted: [Strength2]   },

    //GF
    { name: "GF Sos", type: "grotto", autocompleteName: "X", isImportant: true, zone: "GF", globalArea: "Desert", itemRestricted: [Sos]    },

    //Coloss
    { name: "Coloss Scrub", type: "grotto", autocompleteName: "2 Scrub grotto", isImportant: true, zone: "Coloss", globalArea: "Desert", itemRestricted: [Strength2]  },

    //HC
    { name: "HC Sos", type: "grotto", autocompleteName: "Skull grotto", isImportant: true, zone: "HC", globalArea: "Castle", itemRestricted: [Sos], eraRestricted: "child"   },

    //MKT
    //HF
    { name: "HF Destiny", type: "grotto", autocompleteName: "generic grotto", isImportant: true, zone: "HF", globalArea: "Castle", itemRestricted: [BombBag, MegatonHammer]  },
    { name: "HF Tektike", type: "grotto", autocompleteName: "Tektike", isImportant: true, zone: "HF", globalArea: "Castle", itemRestricted: [BombBag, MegatonHammer]  },
    { name: "HF North", type: "grotto", autocompleteName: "X", isImportant: true, zone: "HF", globalArea: "Castle", itemRestricted: [BombBag, MegatonHammer]  },
    { name: "HF KAK", type: "grotto", autocompleteName: "Skull grotto", isImportant: true, zone: "HF", globalArea: "Castle", itemRestricted: [BombBag, MegatonHammer]  },
    { name: "HF Remote", type: "grotto", autocompleteName: "generic grotto", isImportant: true, zone: "HF", globalArea: "Castle", itemRestricted: [BombBag, MegatonHammer]  },
    { name: "HF Free", type: "grotto", autocompleteName: "generic grotto", isImportant: true, zone: "HF", globalArea: "Castle"  },
    { name: "HF Scrub", type: "grotto", autocompleteName: "Scrub grotto", isImportant: true, zone: "HF", globalArea: "Castle", itemRestricted: [BombBag, MegatonHammer]  },
    { name: "HF Cow", type: "grotto", autocompleteName: "HF Cow GS", isImportant: true, zone: "HF", globalArea: "Castle", itemRestricted: [BombBag, MegatonHammer]  },

    //LLR
    { name: "LLR Free", type: "grotto", autocompleteName: "3 Scrub grotto", isImportant: true, zone: "LLR", globalArea: "Castle", eraRestricted: "child"  },


    //DMT
    { name: "DMT Sos", type: "grotto", autocompleteName: "generic grotto", isImportant: true, zone: "DMT", globalArea: "Mountain", itemRestricted: [Sos]   },
    { name: "DMT Cow", type: "grotto", autocompleteName: "Cow", isImportant: true, zone: "DMT", globalArea: "Mountain", itemRestricted: [BombBag, MegatonHammer]  },


    //DMC
    { name: "DMC Scrub", type: "grotto", autocompleteName: "3 Scrub grotto", isImportant: true, zone: "DMC", globalArea: "Mountain", itemRestricted: [MegatonHammer] },
    { name: "DMC Boulder", type: "grotto", autocompleteName: "generic grotto", isImportant: true, zone: "DMC", globalArea: "Mountain", itemRestricted: [MegatonHammer] },


    //GC
    { name: "GC Scrub", type: "grotto", autocompleteName: "3 Scrub grotto", isImportant: true, zone: "GC", globalArea: "Mountain", eraRestricted: "adult"  },


]

export const Dungeons: Array<MixPoolPlace> = [
    { name: "Deku", type: "dungeon", autocompleteName: "Deku", isImportant: true, zone: "KF", globalArea: "Foret"  },
    { name: "DC", type: "dungeon", autocompleteName: "DC", isImportant: true, zone: "DMT", globalArea: "Mountain"  },
    { name: "Jabu", type: "dungeon", autocompleteName: "Jabu", isImportant: true, zone: "ZF", globalArea: "Zora"  },
    { name: "Ice", type: "dungeon", autocompleteName: "Ice", isImportant: true, zone: "ZF", globalArea: "Zora"  },
    { name: "Forest", type: "dungeon", autocompleteName: "Forest", isImportant: true, zone: "SFM", globalArea: "Foret"  },
    { name: "Fire", type: "dungeon", autocompleteName: "Fire", isImportant: true, zone: "DMC", globalArea: "Mountain"  },
    { name: "Water", type: "dungeon", autocompleteName: "Water", isImportant: true, zone: "LH", globalArea: "Zora" },
    { name: "Shadow", type: "dungeon", autocompleteName: "Shadow", isImportant: true, zone: "GY", globalArea: "Kak" },
    { name: "BotW", type: "dungeon", autocompleteName: "BotW", isImportant: true, zone: "KAK", globalArea: "Kak"  },
    { name: "Spirit", type: "dungeon", autocompleteName: "Spirit", isImportant: true, zone: "Coloss", globalArea: "Desert"  },
    { name: "GTG", type: "dungeon", autocompleteName: "GTG", isImportant: true, zone: "GF", globalArea: "Desert"  },
    { name: "Ganon_Castle", type: "dungeon", autocompleteName: "Ganon Castle", isImportant: true, zone: "OGC", globalArea: "Castle"  },
   
]

export const ImportantPlaces: Array<MixPoolPlace>=[
    { name: "HF Tektike", type: "grotto", autocompleteName: "Tektike", isImportant: true, zone: "HF", globalArea: "Castle"  },
    { name: "LW Theater", type: "grotto", autocompleteName: "Theater", isImportant: true, zone: "LW", globalArea: "Foret"  },
    { name: "GC Goron_Shop", type: "interior", autocompleteName: "Goron Shop", isImportant: true, zone: "GC", globalArea: "Mountain"  },
    { name: "MKT_Bridge Pot/Poe", type: "interior", autocompleteName: "Pot/Poe", isImportant: true, zone: "MKT_Bridge", globalArea: "Castle" },
    { name: "MKT Bazar", type: "interior", autocompleteName: "Bazar", isImportant: true, zone: "MKT", globalArea: "Castle" },
    { name: "MKT Potion", type: "interior", autocompleteName: "Potion", isImportant: true, zone: "MKT", globalArea: "Castle" },
    { name: "Out_ToT ToT", type: "interior", autocompleteName: "ToT", isImportant: true, zone: "Out_ToT", globalArea: "Castle" },
    
    { name: "MKT Sling", type: "interior", autocompleteName: "Sling", isImportant: true, zone: "MKT", globalArea: "Castle" },
    { name: "MKT Bowling", type: "interior", autocompleteName: "Bowling", isImportant: true, zone: "MKT", globalArea: "Castle" },
    { name: "MKT CMG", type: "interior", autocompleteName: "CMG", isImportant: true, zone: "MKT", globalArea: "Castle" },
    { name: "MKT Chus_Shop", type: "interior", autocompleteName: "Chus Shop", isImportant: true, zone: "MKT", globalArea: "Castle" },
    { name: "LLR Silo", type: "interior", autocompleteName: "Silo (Cow)", isImportant: true, zone: "LLR", globalArea: "Castle"  },
    { name: "LLR Talon", type: "interior", autocompleteName: "Talon", isImportant: true, zone: "LLR", globalArea: "Castle" },
    { name: "KAK Bazar", type: "interior", autocompleteName: "Bazar", isImportant: true, zone: "KAK", globalArea: "Kak" },
    { name: "KAK Windmill", type: "interior", autocompleteName: "Windmill", isImportant: true, zone: "KAK", globalArea: "Kak" },
    { name: "LH Lab", type: "interior", autocompleteName: "Lab", isImportant: true, zone: "LH", globalArea: "Zora"  },
    { name: "LH Fishing", type: "interior", autocompleteName: "Fishing", isImportant: true, zone: "LH", globalArea: "Zora"  },
    { name: "ZD Zora_Shop", type: "interior", autocompleteName: "Zora Shop", isImportant: true, zone: "ZD", globalArea: "Zora"  },
    { name: "KF Shop", type: "interior", autocompleteName: "KF Shop", isImportant: true, zone: "KF", globalArea: "Foret"  },
   
]

export const OverworldEntrances: Array<MixPoolPlace> = [

    //KF
    { name: "KF => LW", type: "overworld", autocompleteName: "KF => LW", isImportant: true, zone: "KF", globalArea: "Foret"  },
    { name: "KF => LW_Bridge", type: "overworld", autocompleteName: "KF => LW Bridge", isImportant: true, zone: "KF", globalArea: "Foret"  },
    { name: "KF => Deku", type: "dungeon_entrance", autocompleteName: "KF => LW Bridge", isImportant: true, zone: "KF", globalArea: "Foret"  },
    { name: "Deku => KF", type: "dungeon", autocompleteName: "KF => LW Bridge", isImportant: true, zone: "Deku", globalArea: "Foret", order: 1  },
    { name: "Deku => Ghoma", type: "dungeon", autocompleteName: "KF => LW Bridge", isImportant: true, zone: "Deku", globalArea: "Foret", order: 1  },

    //LW
    { name: "LW => GC", type: "overworld", autocompleteName: "LW => GC", isImportant: true, zone: "LW", globalArea: "Foret"  },
    { name: "LW => SFM", type: "overworld", autocompleteName: "LW => SFM", isImportant: true, zone: "LW", globalArea: "Foret"  },
    { name: "LW => KF", type: "overworld", autocompleteName: "LW => KF", isImportant: true, zone: "LW", globalArea: "Foret"  },
    { name: "LW => ZR", type: "overworld", autocompleteName: "LW => KF", isImportant: true, zone: "LW", globalArea: "Foret", itemRestricted: [ZoraScale, IronBoots]  },
    { name: "LW_Bridge => HF", type: "overworld", autocompleteName: "LW Bridge => HF", isImportant: true, zone: "LW_Bridge", globalArea: "Foret"  },
    { name: "LW_Bridge => KF", type: "overworld", autocompleteName: "LW Bridge => KF", isImportant: true, zone: "LW_Bridge" , globalArea: "Foret" },

    //SFM
    { name: "SFM => LW", type: "overworld", autocompleteName: "SFM => LW", isImportant: true, zone: "SFM", globalArea: "Foret"  },
    { name: "SFM => Forest", type: "dungeon_entrance", autocompleteName: "SFM => LW", isImportant: true, zone: "SFM", globalArea: "Foret", itemRestricted: [HookShot], eraRestricted: "adult" },
    { name: "Forest => SFM", type: "dungeon", autocompleteName: "SFM => LW", isImportant: true, zone: "Forest", globalArea: "Foret", order: 4  },
    { name: "Forest => PG", type: "dungeon", autocompleteName: "SFM => LW", isImportant: true, zone: "Forest", globalArea: "Foret", order: 4  },


    //HF
    { name: "HF => ZR", type: "overworld", autocompleteName: "HF => River", isImportant: true, zone: "HF", globalArea: "Castle"  },
    { name: "HF => KAK", type: "overworld", autocompleteName: "HF => Kak", isImportant: true, zone: "HF", globalArea: "Castle"  },
    { name: "HF => MKT_Bridge", type: "overworld", autocompleteName: "HF => Market Bridge", isImportant: true, zone: "HF", globalArea: "Castle"  },
    { name: "HF => GV", type: "overworld", autocompleteName: "HF => Valley", isImportant: true, zone: "HF", globalArea: "Castle"  },
    { name: "HF => LH", type: "overworld", autocompleteName: "HF => LH", isImportant: true, zone: "HF", globalArea: "Castle"  },
    { name: "HF => LLR", type: "overworld", autocompleteName: "HF => LLR", isImportant: true, zone: "HF", globalArea: "Castle"  },
    { name: "HF => LW_Bridge", type: "overworld", autocompleteName: "HF => LLR", isImportant: true, zone: "HF", globalArea: "Castle"  },

    //HC
    { name: "HC => MKT", type: "overworld", autocompleteName: "HF => River", isImportant: true, zone: "HC", globalArea: "Castle"  },
    { name: "Ganon_Castle => Tower", type: "dungeon", autocompleteName: "HF => River", isImportant: true, zone: "Ganon_Castle", globalArea: "Castle", order: 12  },
    { name: "Ganon_Castle => OGC", type: "dungeon", autocompleteName: "HF => River", isImportant: true, zone: "Ganon_Castle", globalArea: "Castle", order: 12  },
    //LLR
    { name: "LLR => HF", type: "overworld", autocompleteName: "LLR => HF", isImportant: true, zone: "LLR", globalArea: "Castle"  },

    //Valley
    { name: "GV => HF", type: "overworld", autocompleteName: "GV => HF", isImportant: true, zone: "GV", globalArea: "Desert"  },
    { name: "GV => LH", type: "overworld", autocompleteName: "GV => LH", isImportant: true, zone: "GV", globalArea: "Desert", isOneWay: true  },
    { name: "GV => GF", type: "overworld", autocompleteName: "GV => Fortress", isImportant: true, zone: "GV", globalArea: "Desert"  },

    //Fortress
    { name: "GF => GV", type: "overworld", autocompleteName: "GF => Valley", isImportant: true, zone: "GF", globalArea: "Desert"  },
    { name: "GF => Wasteland", type: "overworld", autocompleteName: "GF => Wasteland", isImportant: true, zone: "GF", globalArea: "Desert"  },
    { name: "GF => GTG", type: "dungeon_entrance", autocompleteName: "GF => Wasteland", isImportant: true, zone: "GF", globalArea: "Desert"  },
    { name: "GTG => GF", type: "dungeon", autocompleteName: "GF => Wasteland", isImportant: true, zone: "GTG", globalArea: "Desert", order: 9  },

    //Wasteland
    { name: "Wasteland => GF", type: "overworld", autocompleteName: "Fortress => Wasteland", isImportant: true, zone: "Wasteland", globalArea: "Desert"  },
    { name: "Wasteland => Coloss", type: "overworld", autocompleteName: "Wasteland => Colossus", isImportant: true, zone: "Wasteland", globalArea: "Desert"  },

    //Colosse
    { name: "Coloss => Wasteland", type: "overworld", autocompleteName: "Coloss => Wasteland", isImportant: true, zone: "Coloss", globalArea: "Desert"  },
    { name: "Coloss => Spirit", type: "dungeon_entrance", autocompleteName: "Coloss => Wasteland", isImportant: true, zone: "Coloss", globalArea: "Desert"  },
    { name: "Spirit => Coloss", type: "dungeon", autocompleteName: "Coloss => Wasteland", isImportant: true, zone: "Spirit", globalArea: "Desert", order: 8  },
    { name: "Spirit => Twinrova", type: "dungeon", autocompleteName: "Coloss => Wasteland", isImportant: true, zone: "Spirit", globalArea: "Desert", order: 8  },


    //MKT Bridge
    { name: "MKT_Bridge => HF", type: "overworld", autocompleteName: "MKT Bridge => HF", isImportant: true, zone: "MKT_Bridge", globalArea: "Castle"  },
    { name: "MKT_Bridge => MKT", type: "overworld", autocompleteName: "MKT Bridge => MKT", isImportant: true, zone: "MKT_Bridge", globalArea: "Castle"  },

    //MKT
    { name: "MKT => HC", type: "overworld", autocompleteName: "Market => HC", isImportant: true, zone: "MKT", globalArea: "Castle"  },
    { name: "MKT => ToT", type: "overworld", autocompleteName: "Market => ToT", isImportant: true, zone: "MKT", globalArea: "Castle"  },
    { name: "MKT => MKT_Bridge", type: "overworld", autocompleteName: "MKT => Market Bridge", isImportant: true, zone: "MKT", globalArea: "Castle"  },

    //Outside TOT
    { name: "Out_ToT => MKT", type: "overworld", autocompleteName: "Market => ToT", isImportant: true, zone: "Out_ToT", globalArea: "Castle"  },

    //KAK
    { name: "KAK => HF", type: "overworld", autocompleteName: "KAK => HF", isImportant: true, zone: "KAK", globalArea: "Kak"  },
    { name: "KAK => DMT", type: "overworld", autocompleteName: "KAK => DMT", isImportant: true, zone: "KAK", globalArea: "Kak"  },
    { name: "KAK => GY", type: "overworld", autocompleteName: "KAK => GY", isImportant: true, zone: "KAK", globalArea: "Kak"  },
    { name: "KAK => BotW", type: "dungeon_entrance", autocompleteName: "KAK => GY", isImportant: true, zone: "KAK", globalArea: "Kak", itemRestricted: [Sos]  },
    { name: "BotW => KAK", type: "dungeon", autocompleteName: "KAK => GY", isImportant: true, zone: "BotW", globalArea: "Kak", order: 11  },

    { name: "Kak_Potion =>  Back", type: "overworld", autocompleteName: "KAK => GY", isImportant: true, zone: "Kak_Potion", globalArea: "Kak_Potion"  },
    { name: "Kak_Potion => Front", type: "overworld", autocompleteName: "KAK => GY", isImportant: true, zone: "Kak_Potion", globalArea: "Kak_Potion"  },

    //GY
    { name: "GY => KAK", type: "overworld", autocompleteName: "GY => Kak", isImportant: true, zone: "GY", globalArea: "Kak" },
    { name: "GY => Shadow", type: "dungeon_entrance", autocompleteName: "GY => Kak", isImportant: true, zone: "GY", globalArea: "Kak", itemRestricted: [DinsFire] },
    { name: "Shadow => GY", type: "dungeon", autocompleteName: "GY => Kak", isImportant: true, zone: "Shadow", globalArea: "Kak", order: 7 },
    { name: "Shadow => Bongo", type: "dungeon", autocompleteName: "GY => Kak", isImportant: true, zone: "Shadow", globalArea: "Kak", order: 7 },

    //DMT
    { name: "DMT => KAK", type: "overworld", autocompleteName: "DMT => GC", isImportant: true, zone: "DMT", globalArea: "Mountain" },
    { name: "DMT => GC", type: "overworld", autocompleteName: "DMT => GC", isImportant: true, zone: "DMT", globalArea: "Mountain" },
    { name: "DMT => DMC", type: "overworld", autocompleteName: "DMT => DMC", isImportant: true, zone: "DMT", globalArea: "Mountain" },
    { name: "DMT => Owl", type: "overworld", autocompleteName: "DMT => DMC", isImportant: true, zone: "DMT", globalArea: "Mountain", eraRestricted: "child" , isOneWay: true},
    { name: "DMT => DC", type: "dungeon_entrance", autocompleteName: "DMT => DMC", isImportant: true, zone: "DMT", globalArea: "Mountain" },
    { name: "DC => DMT", type: "dungeon", autocompleteName: "DMT => DMC", isImportant: true, zone: "DC", globalArea: "Mountain", order: 2 },
    { name: "DC => KD", type: "dungeon", autocompleteName: "DMT => DMC", isImportant: true, zone: "DC", globalArea: "Mountain", order: 2 },

    //DMC
    { name: "DMC => DMT", type: "overworld", autocompleteName: "DMC => DMT", isImportant: true, zone: "DMC", globalArea: "Mountain" },
    { name: "DMC => GC", type: "overworld", autocompleteName: "DMC => GC", isImportant: true, zone: "DMC", globalArea: "Mountain" },
    { name: "DMC => Fire", type: "dungeon_entrance", autocompleteName: "DMC => GC", isImportant: true, zone: "DMC", globalArea: "Mountain" },
    { name: "Fire => DMC", type: "dungeon", autocompleteName: "DMC => GC", isImportant: true, zone: "Fire", globalArea: "Mountain", order: 5 },
    { name: "Fire => Volvagia", type: "dungeon", autocompleteName: "DMC => GC", isImportant: true, zone: "Fire", globalArea: "Mountain", order: 5 },

    //GC
    { name: "GC => DMC", type: "overworld", autocompleteName: "GC => DMC", isImportant: true, zone: "GC", globalArea: "Mountain", eraRestricted: "adult" },
    { name: "GC => LW", type: "overworld", autocompleteName: "GC => LW", isImportant: true, zone: "GC", globalArea: "Mountain", itemRestricted:[BombBag, MegatonHammer, Bow, Strength1] },
    { name: "GC => DMT", type: "overworld", autocompleteName: "GC => DMT", isImportant: true, zone: "GC", globalArea: "Mountain" },

    //River
    { name: "ZR => HF", type: "overworld", autocompleteName: "ZR => HF", isImportant: true, zone: "ZR", globalArea: "Zora" },
    { name: "ZR => LW", type: "overworld", autocompleteName: "ZR => LW", isImportant: true, zone: "ZR", globalArea: "Zora", itemRestricted: [ZoraScale, IronBoots] },
    { name: "ZR => ZD", type: "overworld", autocompleteName: "ZR => ZD", isImportant: true, zone: "ZR", globalArea: "Zora", itemRestricted: [ZL] },

    //Domain
    { name: "ZD => ZR", type: "overworld", autocompleteName: "ZD => ZR", isImportant: true, zone: "ZD", globalArea: "Zora" },
    { name: "ZD => LH", type: "overworld", autocompleteName: "ZD => LH", isImportant: true, zone: "ZD", globalArea: "Zora", eraRestricted: "child", itemRestricted: [ZoraScale] },
    { name: "ZD => ZF", type: "overworld", autocompleteName: "ZD => ZF", isImportant: true, zone: "ZD", globalArea: "Zora" },

    //Fountain
    { name: "ZF => ZD", type: "overworld", autocompleteName: "ZF => ZD", isImportant: true, zone: "ZF", globalArea: "Zora" },
    { name: "ZF => Jabu", type: "dungeon_entrance", autocompleteName: "ZF => ZD", isImportant: true, zone: "ZF", globalArea: "Zora", eraRestricted: "child" },
    { name: "ZF => Ice", type: "dungeon_entrance", autocompleteName: "ZF => ZD", isImportant: true, zone: "ZF", globalArea: "Zora", eraRestricted: "adult" },
    { name: "Ice => ZF", type: "dungeon", autocompleteName: "ZF => ZD", isImportant: true, zone: "Ice", globalArea: "Zora", order: 10 },
    { name: "Jabu => ZF", type: "dungeon", autocompleteName: "ZF => ZD", isImportant: true, zone: "Jabu", globalArea: "Zora", order: 3 },
    { name: "Jabu => Barinade", type: "dungeon", autocompleteName: "ZF => ZD", isImportant: true, zone: "Jabu", globalArea: "Zora", order: 3 },

    //Lake
    { name: "LH => ZD", type: "overworld", autocompleteName: "LH => ZD", isImportant: true, zone: "LH", globalArea: "Zora", eraRestricted: "child", itemRestricted: [ZoraScale]},
    { name: "LH => Owl", type: "overworld", autocompleteName: "LH => Owl", isImportant: true, zone: "LH", globalArea: "Zora", eraRestricted: "child", isOneWay: true},
    { name: "LH => HF", type: "overworld", autocompleteName: "LH => HF", isImportant: true, zone: "LH", globalArea: "Zora"},
    { name: "LH => Water", type: "dungeon_entrance", autocompleteName: "LH => HF", isImportant: true, zone: "LH", globalArea: "Zora"},
    { name: "Water => LH", type: "dungeon", autocompleteName: "LH => HF", isImportant: true, zone: "Water", globalArea: "Zora", order: 6},
    { name: "Water => Morpha", type: "dungeon", autocompleteName: "LH => HF", isImportant: true, zone: "Water", globalArea: "Zora", order: 6},

]

export interface MixPoolPlace extends BaseAutocompleteProps {
    name: string,
    type: MixpoolType,
    isImportant: boolean,
    zone: string,
    globalArea?: string,
    eraRestricted?: "child" | "adult",
    itemRestricted?: Array<OotItemDto>,
    order?: number,
    isOneWay?: true
}


export type MixpoolType = "grotto" | "interior" | "dungeon" | "dungeon_entrance" | "overworld"
